export default __webpack_public_path__ + "static/mccoy-003fa15a94b2f5ca001db4802379f4ee.jpg";